import { render, staticRenderFns } from "./training-card.vue?vue&type=template&id=440de1a1&scoped=true&"
import script from "./training-card.vue?vue&type=script&lang=ts&"
export * from "./training-card.vue?vue&type=script&lang=ts&"
import style0 from "./training-card.vue?vue&type=style&index=0&id=440de1a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440de1a1",
  null
  
)

export default component.exports